export const DEFAULT_MAX_ZOOM_SCALE = 3;
const NATIVE_PIXEL_ZOOM = 3;

const getMaxZoomScale = (media: HTMLElement, intrinsicWidth: number): number => {
	const { offsetWidth, offsetHeight } = media;
	if (!offsetWidth || !offsetHeight) return DEFAULT_MAX_ZOOM_SCALE;

	const nativePixelScale = intrinsicWidth / offsetWidth;
	const fillViewportScale = Math.min(window.innerWidth / offsetWidth, window.innerHeight / offsetHeight);

	return Math.max(DEFAULT_MAX_ZOOM_SCALE, nativePixelScale * NATIVE_PIXEL_ZOOM, fillViewportScale);
};

export default getMaxZoomScale;
